import React, { useMemo } from "react";
import "./styles.scss";
import KC_Button, {
  KC_ButtonSize
} from "../../../designsystem/KC_Button/KC_Button";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";
import { LANGUAGE, tt } from "../../../utils/i18n/i18n";
import { useHistory, useLocation } from "react-router-dom";
import { configAnimation, JETPACK_CONFIG } from "../../../utils/routes/routes";
import { baseSteps } from "../../03_Onboarding/helpers/constants";
import NiceModal from "@ebay/nice-modal-react";
import VideoModal from "../../../components/modal/VideoModal/VideoModal";
import VideoIcon from "../../../components/Icons/VideoIcon";
import { ManagedAccountDropdown } from "../../../components/ManagedAccountDropdown/ManagedAccountDropdown";
import { buildPathWithTrackingId } from "../../../utils/routing/routingUtils";

export default function DashboardHeader() {
  const { accountToDisplay, accountToDisplayIndex } =
    useAccountToDisplaySelector();
  const history = useHistory();
  const location = useLocation();

  const videoURL = useMemo(() => {
    const step = baseSteps?.find(
      (s) => !!location.pathname?.includes(`${configAnimation}/${s.pathName}`)
    );
    // @ts-ignore
    return step?.videoURL?.[LANGUAGE] || step?.videoURL?.["en"] || null;
  }, [location.pathname]);

  const handleOpenVideo = () => {
    if (!videoURL) {
      alert(tt("error"));
      return;
    }
    void NiceModal.show(VideoModal, {
      videoURL
    });
  };

  return (
    <div className="d-none d-lg-flex row m-0 dashboard-header">
      <div className="dashboard-header-left">
        <KC_Button
          id="back-to-home-btn"
          size={KC_ButtonSize.Large}
          isInverted={true}
          className="d-flex back-to-home"
          text={tt("returnToHome")}
          extraStyle={{
            width: "unset"
          }}
          onClick={() => {
            history.push(
              buildPathWithTrackingId(
                JETPACK_CONFIG,
                accountToDisplay?.trackingID
              )
            );
          }}
        />
      </div>
      <div className="dashboard-header-middle">
        <ManagedAccountDropdown showAllOption={false} />
      </div>
      <div className="dashboard-header-right">
        <KC_Button
          size={KC_ButtonSize.Large}
          showIconOnTheLeft={true}
          className="ml-auto d-flex"
          customIcon={<VideoIcon />}
          text={tt("explanatory_video")}
          isInverted={true}
          onClick={handleOpenVideo}
          extraStyle={{
            width: 220
          }}
        />
      </div>
    </div>
  );
}
